module.exports = __webpack_public_path__ + "static/landing-page-save-more-9f9f5c053a44130c49bbee7f2804817e.png";